import { useMemo } from 'react';
import { TIME_GREETINGS, INVITATIONS } from '@/lib/ai-chat/constants';

type TimeOfDay = 'morning' | 'afternoon' | 'evening' | 'night';

const getTimeOfDay = (): TimeOfDay => {
  const hour = new Date().getHours();
  if (hour >= 5 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 17) return 'afternoon';
  if (hour >= 17 && hour < 21) return 'evening';
  return 'night';
};

const getRandomItem = <T>(arr: T[]): T => {
  return arr[Math.floor(Math.random() * arr.length)];
};

const getFirstName = (fullName?: string | null, email?: string | null): string => {
  if (fullName) {
    return fullName.split(' ')[0];
  }
  if (email) {
    // Extract name from email (before @)
    const localPart = email.split('@')[0];
    // Capitalize first letter, handle common formats like "john.doe"
    const name = localPart.split(/[._-]/)[0];
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }
  return '';
};

interface UseGreetingOptions {
  fullName?: string | null;
  email?: string | null;
}

interface GreetingResult {
  greeting: string;
  invitation: string;
  firstName: string;
  timeOfDay: TimeOfDay;
}

export const useGreeting = (options: UseGreetingOptions = {}): GreetingResult => {
  const { fullName, email } = options;

  // Memoize so we get the same greeting/invitation during the session
  return useMemo(() => {
    const timeOfDay = getTimeOfDay();
    const greetings = TIME_GREETINGS[timeOfDay] || TIME_GREETINGS.afternoon;
    const firstName = getFirstName(fullName, email);

    return {
      greeting: getRandomItem(greetings),
      invitation: getRandomItem(INVITATIONS),
      firstName,
      timeOfDay,
    };
  }, [fullName, email]);
};

export default useGreeting;
